import { Link } from 'react-router-dom'
import React from 'react'
import story1 from '../../../assets/images/blogpost-holder.png'
import story2 from '../../../assets/images/blogpost-holder.png'
import story3 from '../../../assets/images/blogpost-holder.png'

const Main = () => {
  return (
    <>
        <section className="row_am latest_story" id="blog">
            <div className="container">
                <div className="section_title"  data-aos-duration="1500" data-aos-delay="100">
                    <h2>Read latest <span>story</span></h2>
                    <p>Take a look at some of our blog posts to hear the latest and greatest.</p>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="story_box"  data-aos-duration="1500">
                            <div className="story_img">
                            <img src={story1} alt="image" />
                            <span>45 min ago</span>
                            </div>
                            <div className="story_text">
                                <h3>How Often Do We Hear A Project Has Run Over Budget?</h3>
                                <p>Going Over Budget? Project Directors & Managers screaming down the VOIP boardroom calls asking why have costs been overrun?..</p>
                                <Link to="/blog-single">READ MORE</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="story_box"  data-aos-duration="1500">
                            <div className="story_img">
                            <img src={story2} alt="image" />
                            <span>45 min ago</span>
                            </div>
                            <div className="story_text">
                                <h3>Contract Procurement Process: Track and record your project procurement cycle.</h3>
                                <p>Track & Record Your Project Procurement Cycle The contract procurement process includes the procedures followed by a project or business..</p>
                                <Link to="/blog-single">READ MORE</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="story_box"  data-aos-duration="1500">
                            <div className="story_img">
                            <img src={story3} alt="image" />
                            <span>45 min ago</span>
                            </div>
                            <div className="story_text">
                                <h3>Northern Powerhouse Virtual Trade Mission to Malaysia planned for: September 2021</h3>
                                <p>Looking forward to showcasing our business to overseas buyers in Taiwan this week in a Virtual Mission with UKTI/ToIT and the..</p>
                                <Link to="/blog-single">READ MORE</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> 
    </>
  )
}

export default Main